import dynamic from "next/dynamic";
// const CardRow = dynamic(() => import("components/card/CardRow"));
import CardRow from "components/card/CardRow";

const LinkCard = dynamic(() => import("components/card/LinkCard"));
import StoryLinkCard from "components/card/StoryLinkCard";

const RelatedStories = ({
  stories,
  cardRowRef,
  sideScroll,
  sideScrollButtons,
}) => {
  const relatedStories =
    stories?.map((item, index) => {
      return (
        <StoryLinkCard key={`${item.id}`} story={item} maxTitleLength={40} />
        // <LinkCard
        //   title={item?.title}
        //   slug={`/stories/${item?.slug}`}
        //   image={item?.search_engine_optimization?.metaMedia?.url}
        //   // data1={cardLocation}
        //   data1={`${moment(item?.date_created).format("MMMM DD YYYY")} | ${
        //     item?.author?.authorName
        //   }`}
        //   titleHeight={2}
        //   readMore={true}
        //   tags={[
        //     item?.story_category[0]?.category_name,
        //     item?.country?.countryName,
        //   ]}
        //   key={index}
        // />
      );
    }) ?? [];

  return (
    <CardRow
      cards={relatedStories}
      sectionSlug="/stories"
      sideScroll={sideScroll}
      sideScrollButtons={sideScrollButtons}
      ref={cardRowRef}
    ></CardRow>
  );
};

export default RelatedStories;
